export const calendarScheduleInterviewConstants = {
  // create candidate data
  SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST:
    "SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST",
  SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS:
    "SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS",
  SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE:
    "SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE",

  // create candidate data
  GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST:
    "GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST",
  GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS:
    "GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS",
  GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE:
    "GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE",

  // create candidate data
  GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_REQUEST:
    "GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_REQUEST",
  GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_SUCCESS:
    "GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_SUCCESS",
  GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_FAILURE:
    "GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_FAILURE",

  // create candidate data
  UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST:
    "UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST",
  UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS:
    "UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS",
  UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE:
    "UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE",

  // create candidate data
  UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST:
    "UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST",
  UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS:
    "UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS",
  UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE:
    "UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE",

  // create candidate data
  UNREGISTERED_USER_GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_REQUEST:
    "UNREGISTERED_USER_GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_REQUEST",
  UNREGISTERED_USER_GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_SUCCESS:
    "UNREGISTERED_USER_GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_SUCCESS",
  UNREGISTERED_USER_GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_FAILURE:
    "UNREGISTERED_USER_GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_FAILURE",
};
